import { useMutation } from '@tanstack/react-query'

import { generateCustomBrief } from '../api'

const useGenerateCustomBriefMutation = () => {
  return useMutation(generateCustomBrief)
}

export default useGenerateCustomBriefMutation
